import script from "./AddTopic.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTopic.vue?vue&type=script&setup=true&lang=js"

import "./AddTopic.vue?vue&type=style&index=0&id=01865838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01865838"]])

export default __exports__